import { isDetailsOpen, setDetailsOpen } from './collapse.js';

// Accordion: nur ein Eintrag gleichzeitig offen.
// Muster wie die Kurs-Filter-Dropdowns in main.js — beim "toggle"-Event eines
// geöffneten <details> alle anderen Einträge derselben Gruppe ([data-accordion])
// schließen, weich animiert über collapse.js.
export function initAccordion() {
  document.querySelectorAll('[data-accordion]').forEach((group) => {
    const items = Array.from(group.querySelectorAll('.bfw-accordion__item'));

    items.forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!isDetailsOpen(details)) return;
        items.forEach((other) => {
          if (other !== details) setDetailsOpen(other, false);
        });
      });
    });
  });
}
